var path = '/app/webpack/wealthbar/views/profile/security.html.slim';
var html = "<div class=\"security\"><section><wb-two-factor-auth></wb-two-factor-auth><two-factor-auth-dashboard></two-factor-auth-dashboard></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;